/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProductTable = /* GraphQL */ `
  mutation CreateProductTable(
    $input: CreateProductTableInput!
    $condition: ModelproductTableConditionInput
  ) {
    createProductTable(input: $input, condition: $condition) {
      id
      shirtDesignFront
      shirtDesignBack
      shirtColor
      shirtCategory {
        webflowId
        id
        categoryName
        name
      }
      shirtrealName {
        name
        id
      }
      sellingPrice
      realprice
      days
      target
      noOfCampaigns
      brief
      shirtName
      detail
      designShirt
      designShirtBack
      frontDesign {
        id
        width
        height
        x
        y
      }
      backDesign {
        id
        width
        height
        x
        y
      }
      customerId
      frontImg
      backImg
      color
      quantity
      step
      isDone
      weflowProductId
      weflowProductURL
      isStop
      orders {
        items {
          productId
          price
          quantity
          acceptedOn
          id
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProductTable = /* GraphQL */ `
  mutation UpdateProductTable(
    $input: UpdateProductTableInput!
    $condition: ModelproductTableConditionInput
  ) {
    updateProductTable(input: $input, condition: $condition) {
      id
      shirtDesignFront
      shirtDesignBack
      shirtColor
      shirtCategory {
        webflowId
        id
        categoryName
        name
      }
      shirtrealName {
        name
        id
      }
      sellingPrice
      realprice
      days
      target
      noOfCampaigns
      brief
      shirtName
      detail
      designShirt
      designShirtBack
      frontDesign {
        id
        width
        height
        x
        y
      }
      backDesign {
        id
        width
        height
        x
        y
      }
      customerId
      frontImg
      backImg
      color
      quantity
      step
      isDone
      weflowProductId
      weflowProductURL
      isStop
      orders {
        items {
          productId
          price
          quantity
          acceptedOn
          id
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductTable = /* GraphQL */ `
  mutation DeleteProductTable(
    $input: DeleteProductTableInput!
    $condition: ModelproductTableConditionInput
  ) {
    deleteProductTable(input: $input, condition: $condition) {
      id
      shirtDesignFront
      shirtDesignBack
      shirtColor
      shirtCategory {
        webflowId
        id
        categoryName
        name
      }
      shirtrealName {
        name
        id
      }
      sellingPrice
      realprice
      days
      target
      noOfCampaigns
      brief
      shirtName
      detail
      designShirt
      designShirtBack
      frontDesign {
        id
        width
        height
        x
        y
      }
      backDesign {
        id
        width
        height
        x
        y
      }
      customerId
      frontImg
      backImg
      color
      quantity
      step
      isDone
      weflowProductId
      weflowProductURL
      isStop
      orders {
        items {
          productId
          price
          quantity
          acceptedOn
          id
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createWebfloworders = /* GraphQL */ `
  mutation CreateWebfloworders(
    $input: CreateWebflowordersInput!
    $condition: ModelwebflowordersConditionInput
  ) {
    createWebfloworders(input: $input, condition: $condition) {
      productId
      price
      quantity
      acceptedOn
      id
    }
  }
`;
export const updateWebfloworders = /* GraphQL */ `
  mutation UpdateWebfloworders(
    $input: UpdateWebflowordersInput!
    $condition: ModelwebflowordersConditionInput
  ) {
    updateWebfloworders(input: $input, condition: $condition) {
      productId
      price
      quantity
      acceptedOn
      id
    }
  }
`;
export const deleteWebfloworders = /* GraphQL */ `
  mutation DeleteWebfloworders(
    $input: DeleteWebflowordersInput!
    $condition: ModelwebflowordersConditionInput
  ) {
    deleteWebfloworders(input: $input, condition: $condition) {
      productId
      price
      quantity
      acceptedOn
      id
    }
  }
`;
export const createGarment = /* GraphQL */ `
  mutation CreateGarment(
    $input: CreateGarmentInput!
    $condition: ModelgarmentConditionInput
  ) {
    createGarment(input: $input, condition: $condition) {
      id
      frontImg
      backImg
      frontImgaddress
      backImgaddress
      cost
      category {
        webflowId
        id
        categoryName
        name
      }
      garmentName {
        name
        id
      }
      garmentDescription
      color
      createdAt
      updatedAt
    }
  }
`;
export const updateGarment = /* GraphQL */ `
  mutation UpdateGarment(
    $input: UpdateGarmentInput!
    $condition: ModelgarmentConditionInput
  ) {
    updateGarment(input: $input, condition: $condition) {
      id
      frontImg
      backImg
      frontImgaddress
      backImgaddress
      cost
      category {
        webflowId
        id
        categoryName
        name
      }
      garmentName {
        name
        id
      }
      garmentDescription
      color
      createdAt
      updatedAt
    }
  }
`;
export const deleteGarment = /* GraphQL */ `
  mutation DeleteGarment(
    $input: DeleteGarmentInput!
    $condition: ModelgarmentConditionInput
  ) {
    deleteGarment(input: $input, condition: $condition) {
      id
      frontImg
      backImg
      frontImgaddress
      backImgaddress
      cost
      category {
        webflowId
        id
        categoryName
        name
      }
      garmentName {
        name
        id
      }
      garmentDescription
      color
      createdAt
      updatedAt
    }
  }
`;
export const createCardInfo = /* GraphQL */ `
  mutation CreateCardInfo(
    $input: CreateCardInfoInput!
    $condition: ModelcardInfoConditionInput
  ) {
    createCardInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      city
      region
      postalCode
      country
      phoneNo
      cardNum
      address
      customerId
      cardId
      createdAt
      updatedAt
    }
  }
`;
export const updateCardInfo = /* GraphQL */ `
  mutation UpdateCardInfo(
    $input: UpdateCardInfoInput!
    $condition: ModelcardInfoConditionInput
  ) {
    updateCardInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      city
      region
      postalCode
      country
      phoneNo
      cardNum
      address
      customerId
      cardId
      createdAt
      updatedAt
    }
  }
`;
export const deleteCardInfo = /* GraphQL */ `
  mutation DeleteCardInfo(
    $input: DeleteCardInfoInput!
    $condition: ModelcardInfoConditionInput
  ) {
    deleteCardInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      city
      region
      postalCode
      country
      phoneNo
      cardNum
      address
      customerId
      cardId
      createdAt
      updatedAt
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelpaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      total
      subTotal
      shipCharge
      customerId
      items {
        campaignId
        quantity
        size
        shirtName
        designShirt
        price
        colors
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelpaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      total
      subTotal
      shipCharge
      customerId
      items {
        campaignId
        quantity
        size
        shirtName
        designShirt
        price
        colors
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelpaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      total
      subTotal
      shipCharge
      customerId
      items {
        campaignId
        quantity
        size
        shirtName
        designShirt
        price
        colors
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      paypalEmail
      accountNo
      ibanNo
      WebflowCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      paypalEmail
      accountNo
      ibanNo
      WebflowCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      userId
      userName
      email
      paypalEmail
      accountNo
      ibanNo
      WebflowCustomerId
      createdAt
      updatedAt
    }
  }
`;
export const createProductCategory = /* GraphQL */ `
  mutation CreateProductCategory(
    $input: CreateProductCategoryInput!
    $condition: ModelproductCategoryConditionInput
  ) {
    createProductCategory(input: $input, condition: $condition) {
      id
      categoryName
      webflowId
      createdAt
      updatedAt
    }
  }
`;
export const updateProductCategory = /* GraphQL */ `
  mutation UpdateProductCategory(
    $input: UpdateProductCategoryInput!
    $condition: ModelproductCategoryConditionInput
  ) {
    updateProductCategory(input: $input, condition: $condition) {
      id
      categoryName
      webflowId
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductCategory = /* GraphQL */ `
  mutation DeleteProductCategory(
    $input: DeleteProductCategoryInput!
    $condition: ModelproductCategoryConditionInput
  ) {
    deleteProductCategory(input: $input, condition: $condition) {
      id
      categoryName
      webflowId
      createdAt
      updatedAt
    }
  }
`;
